export default __webpack_public_path__ + "static/media/ecobicis.106bccc4.svg";